(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    const HOME = '[data-localization-home]';
  const query = matchMedia('(max-width: 749px)');
  let booted = false;
  let pending = false;

  const place = () => {
    const home = document.querySelector(HOME);
    if (!home) return;

    const original = document.querySelector(
      '.header-actions:not(.header-actions--drawer) .header-actions__localization'
    );

    const emptyOut = () => {
      home.replaceChildren();
      home.hidden = true;
    };

    if (!original) {
      emptyOut();
      return;
    }

    /* Réglé sur « Ordinateur », il n'a rien à faire dans un tiroir mobile. */
    if (query.matches && original.classList.contains('for-desktop')) {
      emptyOut();
      return;
    }

    /* Le critère est la visibilité de l'original, pas la largeur : réglé sur « Mobile », il n'apparaissait nulle part sur ordinateur. */
    if (original.getBoundingClientRect().width > 0) {
      emptyOut();
      return;
    }

    if (home.firstElementChild) {
      home.hidden = false;
      return;
    }

    const copy = original.cloneNode(true);
    /* Dans le tiroir, la copie doit se voir quel que soit l'écran : sinon « Mobile » la masquait sur ordinateur. */
    copy.classList.remove('for-mobile', 'for-desktop');

    home.append(copy);
    home.hidden = false;
  };

  const replay = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      place();
    });
  };

  const boot = () => {
    if (booted || !document.querySelector(HOME)) return;
    booted = true;
    place();
    query.addEventListener('change', place);
    addEventListener('resize', replay, { passive: true });
    /* Sur le document, pas sur le header : le thème remplace `header-component` à chaque re-rendu. */
    new MutationObserver(replay).observe(document.body, { childList: true, subtree: true });
  };

  boot();
  document.addEventListener('shopify:section:load', boot);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-card-rows"] && !Shopify.designMode) return;
  try {
    const TILE_SELECTOR = '.resource-list__item--media';
  const knownGrids = new WeakMap();
  let booted = false;
  let inProgress = false;
  let frame = null;

  /* La carte est emballée dans un <li> en `display: contents` : on remonte jusqu'à la vraie grille. */
  const gridOf = (tile) => {
    let grid = knownGrids.get(tile);
    if (grid !== undefined) return grid;
    grid = tile.parentElement;
    while (grid && getComputedStyle(grid).display !== 'grid') grid = grid.parentElement;
    knownGrids.set(tile, grid);
    return grid;
  };

  const publish = () => {
    /* Nos propres écritures redimensionnent la grille, donc rappellent ce code. */
    if (inProgress) return;
    inProgress = true;
    try {
      const tiles = [...document.querySelectorAll(TILE_SELECTOR)];
      if (!tiles.length) return;

      /* On mesure la grille sans nos hauteurs : elles étirent les cartes voisines, qui grandiraient à chaque passage. */
      for (const tile of tiles) tile.style.removeProperty('--media-min-height');

      /* Tout mesurer, puis tout écrire : alterner forçait un recalcul de mise en page par tuile. */
      const toPlace = [];
      const gutters = new Map();

      for (const tile of tiles) {
        const grid = gridOf(tile);
        if (!grid) continue;

        /* Placée explicitement (position mobile), la carte porte son span dans grid-row-END, sinon dans START. */
        const tileStyle = getComputedStyle(tile);
        const raw = /span/.test(tileStyle.gridRowEnd) ? tileStyle.gridRowEnd : tileStyle.gridRowStart;
        const span = parseInt(raw.replace('span', ''), 10) || 1;

        let height = 0;
        for (const child of grid.children) {
          if (child.contains(tile) || child.matches(TILE_SELECTOR)) continue;
          if (child.querySelector(TILE_SELECTOR)) continue;
          let measurement = child.getBoundingClientRect().height;
          /* Un enfant en `display: contents` ne mesure rien : c'est son contenu la carte. */
          if (!measurement && child.firstElementChild) {
            measurement = child.firstElementChild.getBoundingClientRect().height;
          }
          if (measurement > 0) {
            height = measurement;
            break;
          }
        }
        if (!height) continue;

        if (!gutters.has(grid)) {
          gutters.set(grid, parseFloat(getComputedStyle(grid).rowGap) || 0);
        }
        const gutter = gutters.get(grid);

        toPlace.push([tile, Math.round(height * span + gutter * (span - 1))]);
      }

      for (const [tile, value] of toPlace) {
        tile.style.setProperty('--media-min-height', `${value}px`);
      }
    } finally {
      inProgress = false;
    }
  };

  const schedule = () => {
    if (frame == null) frame = requestAnimationFrame(() => { frame = null; publish(); });
  };

  const boot = () => {
    if (booted || !document.querySelector(TILE_SELECTOR)) return;
    booted = true;
    schedule();
    addEventListener('load', schedule, { once: true });
    addEventListener('resize', schedule, { passive: true });
    document.fonts?.ready.then(schedule);

    /* Les images des cartes produit arrivent après coup : la grille change de hauteur sans resize. */
    const observer = new ResizeObserver(schedule);
    for (const tile of document.querySelectorAll(TILE_SELECTOR)) {
      const grid = gridOf(tile);
      if (grid) observer.observe(grid);
    }
  };

  boot();
  document.addEventListener('shopify:section:load', () => {
    boot();
    schedule();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slideshow-arrows"] && !Shopify.designMode) return;
  try {
    const PANEL = 'slideshow-arrows[grouped]';
  let booted = false;
  let image = null;

  /* Largeur rendue du panneau groupé, réservée en fin de piste : taille et écart des flèches sont des réglages marchands. */
  const measure = () => {
    for (const panel of document.querySelectorAll(PANEL)) {
      if (panel.getAttribute('placement') === 'above' || panel.getAttribute('placement') === 'below') continue;
      const root = panel.parentElement;
      if (!root) continue;
      const box = panel.getBoundingClientRect();
      const visible = panel.offsetParent !== null && box.width > 1;

      /* Seules les commandes de la moitié de fin (droite, ou gauche en RTL) comptent : la boîte peut couvrir toute la piste. */
      const rtl = getComputedStyle(panel).direction === 'rtl';
      const middle = box.left + box.width / 2;
      let innerEdge = null;
      for (const control of panel.querySelectorAll('.slideshow-control')) {
        const c = control.getBoundingClientRect();
        if (c.width < 1 || (rtl ? c.right > middle : c.left < middle)) continue;
        const edge = rtl ? c.right : c.left;
        if (innerEdge === null || (rtl ? edge > innerEdge : edge < innerEdge)) innerEdge = edge;
      }

      const reserve = rtl ? innerEdge - box.left : box.right - innerEdge;
      const width = visible && innerEdge !== null ? Math.ceil(reserve) : 0;
      root.style.setProperty('--grouped-arrows-width', `${width}px`);
    }
  };

  const schedule = () => {
    if (image == null) image = requestAnimationFrame(() => { image = null; measure(); });
  };

  const boot = () => {
    if (booted || !document.querySelector('slideshow-arrows')) return;
    booted = true;
    measure();
    addEventListener('load', schedule, { once: true });
    addEventListener('resize', schedule, { passive: true });
    document.fonts?.ready.then(schedule);

    const observer = new ResizeObserver(schedule);
    const follow = () => {
      for (const panel of document.querySelectorAll(PANEL)) observer.observe(panel);
    };
    follow();

    /* Les carrousels posent leurs flèches après coup : on suit les arrivées, puis on re-mesure. */
    new MutationObserver(() => {
      follow();
      schedule();
    }).observe(document.body, { childList: true, subtree: true });
  };

  boot();
  document.addEventListener('shopify:section:load', () => {
    boot();
    schedule();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-header-offset"] && !Shopify.designMode) return;
  try {
    const MARKER = '[data-sticky-header-offset]';
  /* Le panneau de filtres s'épingle dans sa propre colonne, sous la pile : ce n'est pas une rangée. */
  const NOT_A_ROW = '.facets-block-wrapper, script, style, link';
  /* L'en-tête publie lui-même son bord bas : le composer en CSS évite une image de retard. */
  const BASE = 'var(--header-bottom, 0px)';
  let booted = false;
  let frame = null;

  const publish = () => {
    frame = null;

    /* Les sections épinglées hors de `.collection-wrapper` lisent cette valeur sur <body>. */
    if (document.body.style.getPropertyValue('--facets-sticky-top') !== BASE) {
      document.body.style.setProperty('--facets-sticky-top', BASE);
    }

    let stack = 0;
    const wrapper = document.querySelector('.collection-wrapper');

    const collectionSection = wrapper?.closest('.shopify-section');
    if (collectionSection) {
      for (const section of document.querySelectorAll('main > .shopify-section')) {
        if (section === collectionSection) break;
        if (section.offsetParent === null) continue;
        if (getComputedStyle(section).position !== 'sticky') continue;
        stack += Math.floor(section.getBoundingClientRect().height);
      }
    }

    for (const row of wrapper?.children ?? []) {
      if (row.matches(NOT_A_ROW)) continue;
      if (row.offsetParent === null) continue;
      /* Seule la position calculée est fiable : un block ne voit pas les réglages d'un autre block. */
      if (getComputedStyle(row).position !== 'sticky') continue;
      const top = stack === 0 ? BASE : `calc(${BASE} + ${stack}px)`;
      /* N'écrire qu'en cas de changement : sinon recalcul de style et transition relancée à chaque image. */
      if (row.style.getPropertyValue('--facets-sticky-top') !== top) {
        row.style.setProperty('--facets-sticky-top', top);
      }
      stack += Math.floor(row.getBoundingClientRect().height);
    }

    const barHeight = `${stack}px`;
    if (document.body.style.getPropertyValue('--facets-bar-height') !== barHeight) {
      document.body.style.setProperty('--facets-bar-height', barHeight);
    }
  };

  const schedule = () => {
    if (frame == null) frame = requestAnimationFrame(publish);
  };

  const boot = () => {
    if (booted || !document.querySelector(MARKER)) return;
    const header = document.querySelector('#header-component');
    if (!header) return;
    booted = true;
    publish();
    addEventListener('load', publish, { once: true });
    /* En capture sur le document : le scroll d'un conteneur ne remonte pas jusqu'à window. */
    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    addEventListener('resize', schedule, { passive: true });
    new ResizeObserver(schedule).observe(header);
    new MutationObserver(schedule).observe(header, {
      attributes: true,
      attributeFilter: ['data-sticky-state', 'sticky'],
    });
  };

  boot();
  document.addEventListener('shopify:section:load', () => {
    boot();
    schedule();
  });
  } catch(e) { console.error(e); }
})();

})();
